// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import faceHappyIcon from "@/assets/icons/face-happy.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type FaceHappyIconProps = Omit<IconProps, "name">;

export function FaceHappyIcon(props: FaceHappyIconProps): React.ReactNode {
  return <Icon name={faceHappyIcon} {...props} />;
}
